import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { isNullOrEmpty } from '../../utils/util';
import ContainerService from '../../services/ContainerService';
import useStateWithPromise from '../../utils/useEffectUpdate';
import { ScannerCode, SelectItem } from './ComponentsUI';

const SelectQueuePosition = (props) => {
    const [positions, setPositions] = useStateWithPromise([]);
    const [isLoading, setIsLoading] = useState(false);

    const onChangeQueue = (event) => {
        const value = event.target.value;
        onChangeData(event);
        if (!isNullOrEmpty(value) && value.length > 0) {
            var filter = props.positions.filter(f => f.queue.toUpperCase().includes(value.toUpperCase()))
            if (filter.length > 0) {
                return setPositions([...filter])
            }

            setIsLoading(true);
            props.load({ status: 1, queue: value, containerSizeId: props.containerSize }, (data) => {
                if (data) {
                    setPositions([...data]);
                    setIsLoading(false);
                }
            });
        }
    }

    const onChangeData = (event) => {
        if (props.onChange) {
            props.onChange(event)
            if (isNullOrEmpty(event.target.value)) {
                onChangeColumn()
            }
        }
    }

    const onChangeDataColumn = (event) => {
        if (props.onChange) {
            props.onChange(event);
            //Envia um onChange atribuindo o id da posição automatico
            props.onChange({
                target: {
                    name: "positionId",
                    value: positions.find(f => f.queue === props.queueValue && f.column === parseInt(event.target.value || 0))?.id
                }
            });
        }
    }

    const onChangeColumn = () => {
        if (props.onChange && isNullOrEmpty(event.target.value)) {
            props.onChange({
                target: {
                    name: "column",
                    value: ""
                }
            });
            props.onChange({
                target: {
                    name: "positionId",
                    value: ""
                }
            });
        }
    }

    const filterColunm = () => {
        return positions.filter(f => f.queue === props.queueValue || "") || [];
    }

    return (
        <div className="row" >
            <div className="input-field no-padding col s5" style={{ alignContent: 'center' }}>
                <SelectItem
                    focus="true"
                    isLoading={isLoading}
                    name="queue"
                    id="queue"
                    required
                    minLength={0}
                    label="Fila"
                    onChangeData={onChangeData}
                    value={props.queueValue || ""}
                    changeEvent="true"
                    onChange={onChangeQueue}
                    data={positions ? positions.map((i) => {
                        return { id: i.queue, text: i.queue };
                    }) : []} />
                <ScannerCode onScanner={(value) => {
                    onChangeQueue({
                        target: {
                            name: "queue",
                            value: value
                        }
                    })
                    document.getElementById('queue').value = value;
                    setTimeout(() => {
                        document.getElementById('column').focus();
                    }, 500);
                }} />
            </div>
            <div className="input-field no-padding col s5" style={{ alignContent: 'center' }}>
                <SelectItem
                    minLength={0}
                    required
                    disabled={isNullOrEmpty(props.queueValue)}
                    id={"column"}
                    name="column"
                    label="Coluna"
                    value={props.columnValue || ""}
                    onChangeData={onChangeDataColumn}
                    onChange={onChangeDataColumn}
                    changeEvent="true"
                    data={filterColunm().map((i) => {
                        return { id: i.column, text: i.column.toString() };
                    })} />

                <ScannerCode onScanner={(value) => {
                    onChangeQueue({
                        target: {
                            name: "column",
                            value: value
                        }
                    })
                    document.getElementById('column').value = value;
                }} />
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        positions: state.containerReducer.positions
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        load: (filter, callback) => {
            dispatch(ContainerService.getPositions(filter, callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelectQueuePosition));
